import React, { useState, useEffect } from "react";
import { Stack, Box, Input, Button, styled } from "@mui/material";
import { theme, Badge } from "@material-ui/core";
import Select from "react-select";
import axios from "axios";

const TXTRoundedDiv = styled("div")(({theme}) => ({
   borderRadius: theme.shape.borderRadius,
   border: "1px solid #6BD5C0",
   width: "100%",
   marginBottom: "5px"
}));

const StyledBox = styled(Box)({
  marginTop: "5px",
  marginBottom: "5px",
  marginRight: "5px"
});

const StyledInput = styled(Input)({
  height: "95%",
  width: "100%",
  marginTop: "2px",
  marginBottom: "2px",
  fontSize: "14px"
});

export default function FormProjectAddPic (props){
    const [ProjectNameList, setProjectNameList]=useState({});
    const [PicInfo, setPicInfo]=useState('');
    const [PicImageLoaded , setPicImageLoaded]=useState(null);
    const [PicImage , setPicImage]=useState(null);
    const [ProjectId, setProjectId]=useState('');
    const [ProjectName, setProjectName]=useState('');
    

    const loadDataToProjectNameList = (loadedData)=>{
        let DataList=[]
        DataList.push({id: 0, value: 'Select Project Name', label: 'Select Project Name'})
        
        loadedData.map(function (data){
          DataList.push({id: data.id, value: data.name, label: data.name});
          console.log("DataList=" + DataList);
        });
        
        setProjectNameList(DataList);
    }
    
    let GetAllProjectsAPIURL="/myapi/ProjectsListView"
    useEffect(()=>{
       fetch(GetAllProjectsAPIURL)
       .then( response => response.json() )
       .then(json => loadDataToProjectNameList(json))
       .finally(()=>{

        })


    }, [])
    
    const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
          ...base,
          backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
      }
    };
    
    const handlePicImage = (e) =>{
      setPicImage(e.target.files[0]);
      setPicImageLoaded(URL.createObjectURL(e.target.files[0]));
    }

    const addProjectPicToAProject = (PicsId) =>{
        let AddImageToProjectAPIURL="/myapi/PostNewProjectPicsView";
        let bodyObj={
            'pics': PicsId,
            'project': ProjectId,
        };
        let headersOption= {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(bodyObj)
        };
        
        fetch(AddImageToProjectAPIURL, headersOption)
        .then( response => response.json())
        .then(json => console.log("json=" + json))
        .finally( () =>{})
        .catch( (error) => console.log("error=" + error) )

    }

    const handleProjectImageSave = () =>{
        let AddImageToProjectAPIURL="/myapi/PicsAPIViews";
        let formData= new FormData();
        formData.append("img", PicImage, PicImage.name);
        let picsId=0;

        axios
        .post(AddImageToProjectAPIURL, formData, {
            headers: { 'Content-type': 'multipart/form-data' }
        })
        .then( response=> {
            console.log(response.data);
            picsId=response.data['id'];
            console.log('id=' + picsId)
        })
        .finally(()=>{
            addProjectPicToAProject(picsId);
        })
        .catch((error)=> console.log("error=" + error))
    }
    
    const handleSaveButtonClicked = () =>{
      let FormData = new FormData();
      let SaveProjectPicAPIURL=""
      FormData.append("img", PicImage, PicImage.name);
      
      axios
      .post(
        SaveProjectPicAPIURL, FormData, {
            headers: { 'Content-type' : 'multipart/form-data'},
       })
        .then( response => console.log(response.data))
        .finally(()=>{

      }).
      catch((error)=> console.log(error))
    }

    return (
    <Stack direction="vertical" spacing={1}>
       
       <StyledBox flex={4}>
         
         <TXTRoundedDiv>
            <Select
            placeholder="Project Name"
            value={ProjectName}
            options={ProjectNameList}
            styles={customStyles}

            onChange={(event)=>{
               setProjectId(event.id);
               setProjectName(event.value);
            }}
            />
         </TXTRoundedDiv>
         
         <TXTRoundedDiv>
            <StyledInput
            placeholder="Pic Info"
            />
         </TXTRoundedDiv>

         <TXTRoundedDiv>
            <StyledInput
            type="file"
            onChange={handlePicImage}
            placeholder="Select Image"
            />

         </TXTRoundedDiv>
         <TXTRoundedDiv>
            <img src={PicImageLoaded} width={350} height={200}
            />
         </TXTRoundedDiv>
         <Button  type="submit" color="secondary" variant="contained" onClick={handleProjectImageSave}>
            SAVE
         </Button>
       </StyledBox>

       <StyledBox flex={4}>

       </StyledBox>

       <StyledBox flex={4}>

       </StyledBox>
    </Stack>
   )
}